import React from 'react';
import PropTypes from 'prop-types';
import Bevel from './Bevel';
import WindowTitleButton from './WindowTitleButton';
import WindowToolbar from './WindowToolbar';
import classNames from 'classnames';
import './Window.css';

class Window extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true
        };
    }
    onCloseClick = () => {
        this.setState({ open: false });
    }
    render() {
        if (!this.state.open) {
            return null;
        }
        let toolbar;
        if (this.props.toolbar) {
            toolbar = (
                <div className="Window-toolbar">
                    <WindowToolbar>
                        {this.props.toolbar}
                    </WindowToolbar>
                </div>
            );
        }

        const classes = classNames('Window', {
            'Window_inactive': !this.context.active
        });
        return (
            <div className={classes}>
                <Bevel>
                    <div className="Window-border">
                        <div className="Window-title">
                            <div className="Window-title-text">
                                {this.props.title}
                            </div>
                            <WindowTitleButton onClick={this.onCloseClick} />
                        </div>
                        {toolbar}
                        <div className="Window-content-container">
                            <Bevel inverse>
                                <div className="Window-content">
                                    {this.props.children}
                                </div>
                            </Bevel>
                        </div>
                    </div>
                </Bevel>
            </div>
        );
    }
}

Window.propTypes = {
    children: PropTypes.any,
    toolbar: PropTypes.any,
    title: PropTypes.string,
    active: PropTypes.bool
};

Window.defaultProps = {
    active: true
};

Window.contextTypes = {
    active: PropTypes.bool
};

export default Window;



// WEBPACK FOOTER //
// ./src/components/Browser/Window.jsx